import firebaseApp from "../../../firebaseInit";

export default {
	async downloadData(context) {
		const userId = context.rootGetters.userId;

		const isCash = (id) => {
			const regex = new RegExp('_cash', "gi");
			return !!id.match(regex)?.length;
		}

		await firebaseApp.firestore()
			.collection("users")
			.doc(userId)
			.collection("transactions")
			.get()
			.then((querySnapshot) => {
				if (!querySnapshot.empty) {
					const data = [];

					querySnapshot.forEach((doc) => {
						const responseData = doc.data();

						const item = {
							amount: responseData.amount,
							balance: responseData.balance / 100,
							cashbackAmount: responseData.cashbackAmount / 100,
							commissionRate: responseData.commissionRate / 100,
							currencyCode: responseData.description,
							hold: responseData.hold,
							id: responseData.id,
							mcc: isCash(responseData.id) ? -1 : responseData.mcc,
							operationAmount: responseData.operationAmount / 100,
							receiptId: responseData.receiptId,
							time: responseData.time, // Зберігаємо timestamp як число для правильного сортування
						};

						data.push(item);
					});

					context.commit('databaseHasError', false);
					context.commit('databaseIsEmpty', false);
					context.commit('fillLocalData', data);
				} else {
					console.log("No transactions found!");
					context.commit('databaseIsEmpty', true);
				}
			}).catch((error) => {
				console.log("Error getting transactions:", error);
				context.commit('databaseHasError', true);
			});
	},
}
